// Unpublished Work © 2026 Deere & Company.

import t from 'tcomb';

export const CustomerSearch = t.struct({
    activeTab: t.maybe(t.String),
    userExplicitlySelected: t.maybe(t.Boolean)
}, {
    defaultProps: {
        activeTab: null
    },
    name: 'CustomerSearchUiState',
    strict: true
});
